import { useOktaAuth } from "@okta/okta-react";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import axiosInstance from "../../api";
import PickupResponse from "../../models/API/responseModels/PickupResponse.model";

function usePickupList({
  params,
  updatePagination,
  sort
}: {
  params: string;
  updatePagination: ({ totalPages }: { totalPages: number }) => void;
  sort: any;
}): UseQueryResult<PickupResponse> {
  const { authState } = useOktaAuth();

  return useQuery({
    queryKey: ["pickupList", { params,sort }],
    queryFn: ({ queryKey }) => {
      const [_key, { params, sort }]: any = queryKey;
      const sortBy: any = {
        confirmationCode: "confirmationCode",
        shippingAddress: "shippingAddress",
        readyDateTime: "readyDateTime",
        organization: "organizationId",
        status: "status",
       };
      return axiosInstance
        .get(`/v1/fedex/pickups${params}${
          !!sort
            ? `${params ? "&" : "?"}sortBy=${sortBy[sort.id]}&sortDirection=${
                sort.desc ? "DESC" : "ASC"
              }`
            : ""
        }`, {
          headers: {
            Authorization: `Bearer ${authState?.accessToken?.accessToken}`,
          },
          // transformResponse,
        })
        .then((res) => {
          updatePagination({ totalPages: res.data.data.totalPages });
          return res.data;
        });
    },
    // staleTime: Infinity,
    enabled: !!params && !!authState?.accessToken?.accessToken,
    refetchOnReconnect: true,
  });
}

export default usePickupList;
